import { Injectable } from '@angular/core';
import { CustomOccProduct, CustomProduct } from '@product/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductIsRentNormalizer implements Converter<Partial<CustomOccProduct>, Partial<CustomProduct>> {
  convert(source: Partial<CustomOccProduct>, target?: CustomProduct): Partial<CustomProduct> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (source.code) {
      target.isRent = this.normalize(source);
    }

    return target;
  }

  private normalize(product: Partial<CustomOccProduct>): boolean {
    return product.code.startsWith('r');
  }
}
